export default __webpack_public_path__ + "static/social-8bccfa1eb835f0262323f6edb8ca9233.jpg";